module.exports = __webpack_public_path__ + "static/img/bi-partnership5.85f8b59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_new/bi-partnership5.png
// module id = OBnP
// module chunks = 1